export const t_global_breakpoint_2xl = {
  "name": "--pf-t--global--breakpoint--2xl",
  "value": "90.625rem",
  "var": "var(--pf-t--global--breakpoint--2xl)"
};
export default t_global_breakpoint_2xl;